module.exports = __webpack_public_path__ + "static/media/shipping-income.0227b0e3.svg";